module.exports = __webpack_public_path__ + "static/media/icon-menu.771874d7.svg";